import { IS_SERVER } from "@/constants";
import { useState, useEffect } from "react";
import { useBreakpointValue } from "@gemini/core";
export const useIsLandscape = () => {
    var _a, _b, _c;
    const [isLandscape, setIsLandscape] = useState(!IS_SERVER &&
        ((_a = window.screen.orientation) === null || _a === void 0 ? void 0 : _a.type.includes("landscape")) &&
        (((_b = window.screen.orientation) === null || _b === void 0 ? void 0 : _b.angle) === 90 ||
            ((_c = window.screen.orientation) === null || _c === void 0 ? void 0 : _c.angle) === 270));
    const breakpoint = useBreakpointValue({
        base: "base",
        md: "md",
        sm: "sm",
        xs: "xs",
    });
    useEffect(() => {
        const handleOrientationChange = () => {
            var _a, _b, _c;
            const isLandscapeOrientation = ((_a = window.screen.orientation) === null || _a === void 0 ? void 0 : _a.type.includes("landscape")) &&
                (((_b = window.screen.orientation) === null || _b === void 0 ? void 0 : _b.angle) === 90 ||
                    ((_c = window.screen.orientation) === null || _c === void 0 ? void 0 : _c.angle) === 270);
            const isSmallBreakpoint = breakpoint === "sm" || breakpoint === "xs";
            const isMediumOrBaseBreakpoint = breakpoint === "base" || breakpoint === "md";
            const isBelow600px = window.screen.availHeight < 600;
            if ((isSmallBreakpoint || (isMediumOrBaseBreakpoint && isBelow600px)) &&
                isLandscapeOrientation) {
                setIsLandscape(true);
            }
            else {
                setIsLandscape(false);
            }
        };
        window.addEventListener("orientationchange", handleOrientationChange);
        window.addEventListener("resize", handleOrientationChange);
        return () => {
            window.removeEventListener("orientationchange", handleOrientationChange);
            window.removeEventListener("resize", handleOrientationChange);
        };
    }, [breakpoint]);
    return isLandscape;
};
